/**
 * @file  functions/audit/index.ts
 * @description  function library for the audit api
 *
 * @author dlima (dlima-electron)
 *
 */
import { put, post, postExternal } from '../index';
import { Audit } from './audit.model';

/**
 * sets the audit
 * @param data the audit document
 */
const setAudit = async (data: Audit): Promise<Audit> => {
  const result: Audit = await post<Audit>('audit', data);
  return result;
};

/**
 * updates the audit
 * @param data the audit document
 */
const updateAudit = async (data: Audit): Promise<Audit> => {
  const result: Audit = await put<Audit>(`audit/${data.id}`, data);
  return result;
};

/**
 * sets/updates the audit
 * @param data the audit document
 */
export const saveAudit = async (data: Audit): Promise<Audit> => {
  if (data.id) {
    return updateAudit(data);
  }
  return setAudit(data);
};

/**
 * Send an audit message to external services
 * @param data the audit information for the current session
 */
export const submitAudit = async (data: Audit): Promise<void> => {
  const apiUrl = process.env.REACT_APP_API_GATEWAY;
  if (apiUrl) {
    const route = apiUrl + '/crm/v1/audit';
    postExternal<Audit, null>(route, data);
  }
};
